import { ApiHandler as makeReq } from "./ApiHandler";
import { FileUploadApiHandler as makeFileUploadReq } from "./ApiHandler";

const API_BASE = "cdktalentacquisition/api";

export default {
  addEmployee: employeeIdDetails => {
    return makeFileUploadReq({
      url: `${API_BASE}/addemployee`,
      method: "POST",
      data: employeeIdDetails
    });
  },
  getEmployeeList: () => {
    return makeReq({
      url: `${API_BASE}/getemployeelist`,
      method: "GET"
    });
  },
  getEmpDocuments: employeeId => {
    return makeReq({
      url: `${API_BASE}/getempdocuments/`,
      method: "GET",
      data: {
        employeeId: employeeId
      }
    });
  }
};
